export default ({ axios }) => ({
    login: (user) => axios.post(`/users/login`, user),
    logout: () => axios.post(`/users/logout`),
    currentSession: () => axios.get(`/current-session`),
    renewSession: () => axios.get(`/users/token-refresh`),
    passwordReset: (body) => axios.post(`users/forgot-password`,body ),
    passwordResetConfirm: (body) => axios.post(`users/reset-password`,body ),
    passwordConfirm: (body) => axios.get(``, body),//users/reset-password 'token' => 'required', 'email' => 'required|email', 'password' => 'required|string|min:8'
    confirmAccount: (body) => axios.get(`/verify-email`, body),
})